import React from 'react';
import '../styles/App.css';
import '../styles/Table.css'
import {trackPromise} from "react-promise-tracker";

/**
 * Class used for rendering the hardware selectors associated with GSPAS Vehicle
 *
 * @author Ethan Jones
 */
class GspasHardwareSelector extends React.Component{

    serverApi;

    /**
     * Constructor for GspasHardwareSelector, instantiates a new api object
     * @param props
     */
    constructor(props) {
        super(props);
        this.serverApi = this.props.serverApi
    }

    state = {
        initialRender: true,
        stopRender: false,
        stepId: [],
        hardwareLists: []
    }

    /**
     * Initial method that runs to set up stepId and hardware lists
     * @returns {Promise<void>}
     */
    async setInitialRender(){
        let hardwareLists = []
        this.state.stepId =  await Object.keys(this.props.progSeqData.stepIdPartNumberMap).map(key => key)
        this.state.stepId.map((async key =>{
            hardwareLists.push(this.props.progSeqData.hardwarePartNumberListMap[key])
        }))
        await this.props.initHardwareHandler(this.state.stepId.length)
        await this.setState({
            initialRender: false,
            hardwareLists: hardwareLists
        })
    }

    componentDidMount() {

    }

    /**
     * Handler for hardware selections
     *
     * @param e hardware part number
     * @param index
     * @returns {Promise<void>}
     */
    async handleHardwareSelection(e, index){

        await this.props.hardwareHandler(this.state.stepId[index],e, this.state.stopRender)
        if(this.state.stopRender){
            await this.getGspasHwdCalData()
        }
    }

    /**
     * Iterates through hardware part numbers and inserts them into dropdown selection menu
     * @returns {*}
     */
    renderGspasHardwareSelector(){

        return(
            <div>
            {this.state.hardwareLists && this.state.hardwareLists.map((hardwareList, index) =>(
                    <select className={"hardwareSelector"} onChange={async e=>this.handleHardwareSelection(
                        e.target.value, index)}>
                        <option value={"default"} id = {"hardwareSelector-"+index}>Select 8 Digit Hardware Part Number</option>
                        {
                            hardwareList.map((data, index)=>(
                            <option>{data}</option>
                            ))
                        }
                    </select>
                ))}
            </div>
        )
    }

    /**
     * Method called to have api object call Sps2 Info Backend and get updated Calibration Data
     *
     * @returns {Promise<void>}
     */
    async getGspasHwdCalData(){
        if(this.props.hardwareSelectionCount === this.props.getGspasCalDataCounter) {
            this.setState({stopRender: true})
            await trackPromise(this.serverApi.getGspasHardwareCalData(this.props.progSeqData, this.props.calDataHandler,
                this.props.errorHandler))
        }
    }

    /**
     * Main render method of Gspas Hardware Selector Class
     * @returns {*}
     */
    render(){
        if(!this.state.stopRender){
            this.getGspasHwdCalData()
        }
        if(this.state.initialRender){
            this.setInitialRender()
            return(<div></div>)
        }else{
            return this.renderGspasHardwareSelector()
        }
    }
}

export default GspasHardwareSelector;